import { render, staticRenderFns } from "./PUCSvgSIcon.vue?vue&type=template&id=270f0c02&functional=true&"
import script from "./PUCSvgSIcon.vue?vue&type=script&lang=js&"
export * from "./PUCSvgSIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports